import {
    Button,
    Container,
    Stack
} from '@mui/material';
import UpdateEmailForm from 'components/UpdateEmailForm';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchAccount } from 'slices/accountActions';
import { useAppDispatch } from 'utilities/hooks';

const EmailUpdatePage = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        dispatch(fetchAccount());
    }, []);

    return <>
        <Container component="main" maxWidth="xs">
            <Stack spacing={5} sx={{ mt: 3 }}>
                <UpdateEmailForm />
                <Button
                    onClick={() => {
                        navigate('/profile');
                    }}
                    fullWidth
                    variant="outlined"
                    size="large"
                    disableElevation
                    sx={{ mt: 3, mb: 3 }}
                >
                    Back
                </Button>
            </Stack>
        </Container>
    </>;
};

export default EmailUpdatePage;